module.exports = __webpack_public_path__ + "static/PTMono-Regular-f0d5d13327676bfa2221ac9e48eaff4f.woff2";